const fragment = `
  id
  salesRepresentatives {
    id
    name
    email
    phones
    city {
      name
      state
    }
  }
  minLotPrice
  lotMapParams
  standardLotWorksProductTypes
  enableLotMap
  productType {
    id
    name
    imageUrl
  }
`;

export const listCommunityProductTypesQuery = `
  query ListCommunityProductTypes(
    $filter: CommunityProductTypeFilterInput
  ) {
    items: listCommunityProductTypes(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getCommunityProductTypeQuery = `
  query GetCommunityProductType($id: Int!) {
    item: getCommunityProductType(id: $id) {
      ${fragment}
    }
  }
`;

export const createCommunityProductTypeQuery = `
  mutation CreateCommunityProductType(
    $input: CreateCommunityProductTypeInput!
  ) {
    item: createCommunityProductType(input: $input) {
      ${fragment}
    }
  }
`;

export const updateCommunityProductTypeQuery = `
  mutation UpdateCommunityProductType(
    $input: UpdateCommunityProductTypeInput!
  ) {
    item: updateCommunityProductType(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteCommunityProductTypeQuery = `
  mutation DeleteCommunityProductType(
    $id: Int!
  ) {
    item: deleteCommunityProductType(id: $id) {
      ${fragment}
    }
  }
`;

export const sortCommunityProductTypesQuery = `
  mutation SortCommunityProductTypes(
    $communityId: Int!,
    $ids: [Int!]!
  ) {
    items: sortCommunityProductTypes(communityId: $communityId, ids: $ids) {
      id
    }
  }
`;
